import axios from 'axios'
import { QS_CONFIG } from '../../../features/common/Utilities'
import qs from 'query-string'
import { parsedSearch } from 'BFF/utils/utils'
import { CATALOGO_ENDPOINT } from 'common/endpoints'
//This BFF gets counters for Vista - Vendedor

export async function getCounters(search, cancelToken) {
    const newSearch = qs.stringify(parsedSearch(search), QS_CONFIG)
    return await axios.get(`${CATALOGO_ENDPOINT}/counters/?${newSearch}`, { cancelToken })
}
